import { PaymentPlatformResponseDTO } from '@/core/api/dtos/response/payment/paymentPlatform'
import { PaymentPlatform } from '@/core/api/entities/payment/paymentPlatform'

export class PaymentPlatformMapper {
	static toEntity(dto: PaymentPlatformResponseDTO): PaymentPlatform {
		return PaymentPlatform.create({
			id: dto.id,
			name: dto.name,
			code: dto.code,
			active: dto.active,
		})
	}

	static toEntities(dtos: PaymentPlatformResponseDTO[]): PaymentPlatform[] {
		return dtos.map(this.toEntity)
	}
}
